'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { getMonolithApiHeaders } from '@udemy-v2/api-fetch';
interface CourseLandingComponentsApiOptions {
  enabled?: boolean;
}
export function useCourseLandingComponentsApi(courseId, component, t0) {
  const $ = _c(12);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const t2 = String(courseId);
  let t3;
  if ($[2] !== component || $[3] !== t2) {
    t3 = ["course-landing-components", t2, component];
    $[2] = component;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== component || $[6] !== courseId) {
    t4 = async () => {
      const response = await fetch(`/api-2.0/course-landing-components/${courseId}/me/?components=${component}`, {
        headers: {
          ...getMonolithApiHeaders(),
          "Content-Type": "application/json"
        }
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch course landing components: ${response.status} ${response.statusText}`);
      }
      return response.json() as Promise<TResponse>;
    };
    $[5] = component;
    $[6] = courseId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = options.enabled ?? true;
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5,
      retry: false
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return useQuery(t6);
}